import React from 'react';

const AboutUs = () => {
  return (
    <div className="mt-12">
      <div className="flex flex-col lg:flex-row max-w-screen-lg text-[#0a3039] mx-auto">
        {/* Left Section */}
        <div className="lg:w-[30%] flex justify-center lg:justify-end">
          <h1 className="text-[80px] sm:text-[120px] z-20 md:text-[180px] lg:text-[180px] leading-none">We</h1>
        </div>
 {/* Right Section */}

        <div className="lg:w-[70%] pt-6 sm:pt-12 lg:pt-[155px] px-4 lg:pl-8 navbar-link">
          <h2 className="text-3xl sm:text-[#16bab1]xl md:text-5xl font-semibold">
            are kindergarten and childhood is our passion
          </h2>
          <p className="font-medium text-sm sm:text-md md:text-md font-sans mt-4">
  At <span className="text-[#e84c24]">Kalam Kids Kindergarten</span>, we believe that a child’s first steps into education should be guided by love, passion, and creativity. Our team of dedicated educators brings learning to life with enthusiasm, care, and expertise. They create a nurturing environment where every child feels valued, encouraged, and inspired to explore their potential.

  Take a closer look at <strong>“Our Family”</strong>, the amazing individuals who bring their unique talents to the classroom each day. From sparking curiosity to building confidence, they are committed to making every moment a joyful and impactful learning experience. At Kalam Kids, we don’t just teach; we shape futures with passion and purpose.
</p>
 </div>
</div> 
    </div>  
  );
};

export default AboutUs;
